import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserState } from "../../types/types";
import { FaRegUserCircle } from "react-icons/fa";
import fetching from "../../helpers/fetching/fetching";
import fireAlert from "../../helpers/alerts/fireAlert";
import { removeUserToken } from "../../redux/features/user/userSlice";
import { useNavigate } from "react-router";
import ConfirmationAlert from "../alerts/ConfirmationAlert";
import { Button } from "@mui/material";
import { IoIosLogOut } from "react-icons/io";

const UserMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userToken = useSelector((state: UserState) => state.user.userToken);

  const [openDialog, setOpenDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logoutUser = async () => {
    setOpenDialog(false);
    fetching(`/logout`, userToken, "POST")
      .then((res) => res.json())
      .then((data) => {
        dispatch(removeUserToken());
        fireAlert("تم تسجيل الخروج بنجاح", "success");
        navigate("/login");
      })
      .catch((error) => {
        dispatch(removeUserToken());
        fireAlert("تم تسجيل الخروج بنجاح", "success");
        navigate("/login");
      });
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <IconButton
          onClick={handleClick}
          size="small"
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <Avatar
            sx={[
              (theme) => ({
                width: 32,
                height: 32,
              }),
              (theme) =>
                theme.applyStyles("light", {
                  backgroundColor: theme.palette.primary.light,
                  color: "#fff",
                }),
              (theme) =>
                theme.applyStyles("dark", {
                  backgroundColor: "#ffffff20",
                  color: "#fff",
                }),
            ]}
          >
            <FaRegUserCircle size={24} />
          </Avatar>
        </IconButton>
      </Box>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => setOpenDialog(true)}
          sx={{ color: "error.main" }}
        >
          <ListItemIcon sx={{ color: "error.main" }}>
            <IoIosLogOut />
          </ListItemIcon>
          تسجيل الخروج
        </MenuItem>
      </Menu>

      <ConfirmationAlert
        open={openDialog}
        setOpen={setOpenDialog}
        title={"تسجيل خروج"}
        DialogActionNodes={
          <>
            <Button onClick={logoutUser} variant="contained">
              تسجيل الخروج
            </Button>
            <Button onClick={() => setOpenDialog(false)}>الغاء</Button>
          </>
        }
      >
        <Typography variant="body2">
          هل انت متاكد انك تريد تسجيل الخروج
        </Typography>
      </ConfirmationAlert>
    </>
  );
};

export default UserMenu;
